<!--
  install-help.component.html
  The public /install-help page. Owns its own header because the app shell is
  hidden on this route (AppComponent.isStandalonePage) — the shell's toolbar is
  built around a signed-in user and this page has none. The step content is the
  shared app-pwa-instructions; nothing about the steps is written here.
-->

<ion-header>
  <ion-toolbar>
    <!-- Direct children of ion-toolbar so the slots actually reach it: a nested
         wrapper would leave slot="start"/"end" unhonoured and stack the row. -->
    <ion-buttons slot="start">
      <img src="assets/delivery-box.png" class="install-help-logo" alt="ReceivingMgr">
    </ion-buttons>

    <ion-title>ReceivingMgr</ion-title>

    <ion-buttons slot="end">
      <!-- color="light": the toolbar is brand red and sets no content color, so a
           default-colored button would be near-invisible on it (same reason the
           app shell's header buttons pin their color). -->
      <ion-button (click)="goToApp()" color="light">
        <ion-icon name="arrow-forward-outline" slot="end"></ion-icon>
        Go to app
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="install-help-page">

    <!-- Viewed from the installed app: say so, but leave the steps in place for
         anyone reading them on someone else's behalf. -->
    <div class="install-help-installed-note" *ngIf="alreadyInstalled">
      <ion-icon name="checkmark-circle-outline" class="install-help-installed-icon" aria-hidden="true"></ion-icon>
      <div>
        <p class="install-help-installed-title">You’re already running the installed app.</p>
        <p class="install-help-installed-text">
          Nothing to do here — the steps below are for installing it on another device.
        </p>
      </div>
    </div>

    <app-pwa-instructions></app-pwa-instructions>

  </div>
</ion-content>
